'use client';

import { useEffect, useState } from 'react';
import { DynamicAlertBanner } from '../alert-banners/DynamicAlertBanner';
import { useAccountContext } from './account-provider';
import { LucideIcon } from '@fileverse/ui';

export const MigrationAlertBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { walletAddress } = useAccountContext();

  useEffect(() => {
    // Check if the localStorage key exists for the current wallet address
    if (walletAddress) {
      const hasMigrationIssue = localStorage.getItem(
        `impossible_migration_${walletAddress}`
      );
      if (hasMigrationIssue === 'true') {
        setShowBanner(true);
      }
    }
  }, [walletAddress]);

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-8 right-4 z-50">
      <DynamicAlertBanner
        open={showBanner}
        onOpenChange={(open) => {
          if (!open) {
            localStorage.removeItem(`impossible_migration_${walletAddress}`);
          }
          setShowBanner(open);
        }}
        icon={
          <div className="flex items-center justify-center px-[9px] py-[5px] rounded color-bg-secondary">
            <span className="text-heading-lg">‼️</span>
          </div>
        }
        title="Attention: Migration could not be completed"
        description={
          <div className="flex flex-col gap-2">
            <p>
              To finalise the document migration, please log in from the device
              you originally used to create your dDocs account.
            </p>
            <p>
              If you’re already on your original device and the migration isn’t
              working, please reach out to us. Team Fileverse will assist asap!
            </p>
          </div>
        }
        footer={
          <div className="border-t color-border-default">
            <div className="flex justify-center items-center color-text-default text-helper-text-sm-bold">
              <button
                className="w-full h-[46px] flex justify-center items-center gap-1 hover:color-bg-secondary-hover transition-all"
                onClick={() => {
                  window.open('mailto:feedback@fileverse.io', '_blank');
                }}
              >
                <LucideIcon name="Mail" size="sm" />
                Contact us
              </button>
            </div>
          </div>
        }
        variant="default"
        className="max-w-[320px] border color-border-default shadow-elevation-4 flex flex-col gap-2 !px-0 !pb-0"
        contentClassName="px-3"
      />
    </div>
  );
};
